import { PiArrowFatDownFill, PiArrowFatUpFill } from "react-icons/pi";
import { FaTrash } from "react-icons/fa";
import { Tooltip, TooltipTrigger } from "@artis/ui";
import cn from "mcn";

import { PointerIcon } from "../../../icons";
import { Button } from "../../../ui";
import { AddRowButton } from "../Shared";

export const ActionBar = ({
  onAdd,
  onRemove,
  onTarget,
  onMoveUp,
  onMoveDown,
  disabled,
}: {
  onAdd?: () => void;
  onRemove?: () => void;
  onTarget?: () => void;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  disabled?: boolean;
}) => {
  return (
    <div className={cn("flex gap-4 flex-wrap items-center", !onAdd && "my-3 px-3")}>
      {onAdd && <AddRowButton onClick={onAdd} />}
      <div className="flex-1 min-w-0" />
      {onMoveUp && (
        <TooltipTrigger>
          <div>
            <Button
              variant="outline"
              color="neutral"
              size="iconOnly"
              iconWidth={36}
              onClick={onMoveUp}
              disabled={disabled}
            >
              <PiArrowFatUpFill style={{ fontSize: "12px" }} />
            </Button>
          </div>
          <Tooltip>Move rule(s) higher in priority</Tooltip>
        </TooltipTrigger>
      )}
      {onMoveDown && (
        <TooltipTrigger>
          <div>
            <Button
              variant="outline"
              color="neutral"
              size="iconOnly"
              iconWidth={36}
              onClick={onMoveDown}
              disabled={disabled}
            >
              <PiArrowFatDownFill style={{ fontSize: "12px" }} />
            </Button>
          </div>
          <Tooltip>Move rule(s) lower in priority</Tooltip>
        </TooltipTrigger>
      )}
      {onTarget && (
        <TooltipTrigger>
          <div>
            <Button
              variant="outline"
              color="neutral"
              size="iconOnly"
              iconWidth={36}
              onClick={onTarget}
              disabled={disabled}
            >
              <PointerIcon className="w-5 h-5" />
            </Button>
          </div>
          <Tooltip>Highlight selected cell(s)</Tooltip>
        </TooltipTrigger>
      )}
      {onRemove && (
        <TooltipTrigger>
          <div>
            <Button
              data-testid="delete"
              variant="outline"
              color="neutral"
              size="iconOnly"
              iconWidth={36}
              onClick={onRemove}
              disabled={disabled}
            >
              <FaTrash />
            </Button>
          </div>
          <Tooltip>Delete rule(s)</Tooltip>
        </TooltipTrigger>
      )}
    </div>
  );
};
